'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Reagan = require('conversations-visitor-ui/constants/Reagan');

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _RequestStatus = require('conversations-core/data/records/RequestStatus');

var _RequestStatus2 = _interopRequireDefault(_RequestStatus);

var _visibility = require('conversations-lib/visibility');

var visibility = _interopRequireWildcard(_visibility);

var _IndexContainer = require('conversations-visitor-ui/containers/IndexContainer');

var _IndexContainer2 = _interopRequireDefault(_IndexContainer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Application = _react2.default.createClass({
  displayName: 'Application',

  propTypes: {
    fetchWidget: _react.PropTypes.func.isRequired,
    leaveChannels: _react.PropTypes.func.isRequired,
    registerContainerRef: _react.PropTypes.func.isRequired,
    requestStatus: _react.PropTypes.instanceOf(_RequestStatus2.default).isRequired,
    setWindowVisible: _react.PropTypes.func.isRequired,
    onUpdateSize: _react.PropTypes.func.isRequired,
    onUpdateOpened: _react.PropTypes.func.isRequired,
    onHideWelcomeMessage: _react.PropTypes.func.isRequired
  },

  componentWillMount: function componentWillMount() {
    this.props.fetchWidget();
  },
  componentDidMount: function componentDidMount() {
    var setWindowVisible = this.props.setWindowVisible;

    if (visibility.isHidden()) {
      setWindowVisible(false);
    }
    visibility.addVisibilityChangeListener(this.handleVisibilityChange);
    window.addEventListener('beforeunload', this.handleClose);
  },
  componentWillUnmount: function componentWillUnmount() {
    visibility.removeVisibilityChangeListener(this.handleVisibilityChange);
    window.removeEventListener('beforeunload', this.handleClose);
  },
  handleVisibilityChange: function handleVisibilityChange(_ref) {
    var isVisible = _ref.isVisible;
    var setWindowVisible = this.props.setWindowVisible;


    setWindowVisible(isVisible);
  },
  isLoading: function isLoading() {
    var widgetData = this.props.requestStatus.widgetData;


    var loadingStatuses = (0, _immutable.List)([_RequestStatusTypes2.default.UNINITIALIZED, _RequestStatusTypes2.default.PENDING]);

    return loadingStatuses.includes(widgetData);
  },
  hasApiError: function hasApiError() {
    var widgetData = this.props.requestStatus.widgetData;


    return widgetData === _RequestStatusTypes2.default.FAILED;
  },
  handleClose: function handleClose() {
    this.props.leaveChannels();
  },
  render: function render() {
    var _classNames;

    var _props = this.props,
        registerContainerRef = _props.registerContainerRef,
        onUpdateSize = _props.onUpdateSize,
        onUpdateOpened = _props.onUpdateOpened,
        onHideWelcomeMessage = _props.onHideWelcomeMessage;


    var classes = (0, _reactUtils.classNames)('widget-app-container', (_classNames = {}, _defineProperty(_classNames, _Reagan.CLASSES.VISITOR_SUCCESS, !this.isLoading() && !this.hasApiError()), _defineProperty(_classNames, _Reagan.CLASSES.VISITOR_ERROR, this.hasApiError()), _classNames));

    return _react2.default.createElement(
      'div',
      { ref: registerContainerRef, className: classes },
      _react2.default.createElement(_IndexContainer2.default, {
        onUpdateSize: onUpdateSize,
        onUpdateOpened: onUpdateOpened,
        onHideWelcomeMessage: onHideWelcomeMessage
      })
    );
  }
});

exports.default = Application;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/Application.js
// module id = 414
// module chunks = 0 1